module.exports = "/_next/static/images/CollectionSourceFunctions@2x-17eac567c19c0025445d3d0e67a8ec38.png";